import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'

import ContextProvider from '~/provider/ContextProvider'

import { GlobalStyle } from '~/utils/styles'
import Header from '~/components/Header'
import SiteBackground from '~/components/SiteBackground'

const Wrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  padding: 1rem 2rem;
  box-sizing: border-box;
`

const Layout = ({ children }) => {
  return (
    <ContextProvider>
      <GlobalStyle />
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <>
            <SiteBackground />
            <Header siteTitle={data.site.siteMetadata.title} />
            <Wrapper>{children}</Wrapper>
          </>
        )}
      />
    </ContextProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
